function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState, useEffect } from 'react';
import { CLIENTS } from "./../api/config/config";
import { parseMessagesByDate } from "../components/utils/parseMessageByDate";
import InboxTypes from "../components/utils/enums/inboxTypes.enum";
import { useNavigate } from 'react-router-dom';
import sortConversationsByDate from "../components/utils/sortConversationsByDate";
import sortConversationsByUnreadStatus from "../components/utils/sortConversationsByUnreadStatus";
const CONVERSATIONS_PER_PAGE = 8;
const transformConversation = async conversation => {
  var _conversation$attribu;
  const {
    lastMessage,
    lastReadMessageIndex,
    status,
    attributes: {
      subject_type,
      subject_id
    },
    state: {
      current,
      dateUpdated
    },
    attributes,
    sid
  } = conversation;
  const twilioParticipants = await conversation.getParticipants();
  const participants = (_conversation$attribu = conversation.attributes.participants_attributes) === null || _conversation$attribu === void 0 ? void 0 : _conversation$attribu.map(participant => {
    const currentParticipant = twilioParticipants.find(_ref => {
      let {
        identity
      } = _ref;
      return identity === participant.id;
    });
    return _objectSpread(_objectSpread({}, participant), {}, {
      lastReadMessageIndex: currentParticipant === null || currentParticipant === void 0 ? void 0 : currentParticipant.lastReadMessageIndex
    });
  });
  const returnObj = {
    sid,
    participants,
    getMessages: async () => await conversation.getMessages(),
    sendMessage: async message => await conversation.sendMessage(message),
    updateLastReadMessageIndex: async sentMessage => await conversation.updateLastReadMessageIndex(sentMessage),
    isFav: attributes.is_favourite || false,
    lastMessageDate: (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.dateCreated) && new Date(lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.dateCreated),
    unreadMessages: lastMessage && lastReadMessageIndex !== (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.index),
    getParticipants: async () => await conversation.getParticipants(),
    joined: status === "joined",
    subjectType: subject_type,
    subject: subject_id,
    setAllMessagesRead: async () => await conversation.setAllMessagesRead(),
    state: {
      current,
      dateUpdated
    },
    attributes
  };
  if (subject_type === "case") {
    returnObj.case = {
      id: subject_id
    };
  }
  if (subject_type === "referral") {
    returnObj.referral = {
      id: subject_id
    };
  }
  return returnObj;
};
export const useConversations = _ref2 => {
  let {
    messageCenterLogger,
    archiveEnabled,
    pageNumber
  } = _ref2;
  const offset = pageNumber * CONVERSATIONS_PER_PAGE;
  const pageIndex = pageNumber - 1;
  const [initialized, setInitialized] = useState(false);
  const [rawConversationList, setRawConversationList] = useState([]);
  const [inboxType, setInboxType] = useState(InboxTypes.INBOX);
  const {
    twilioClient
  } = CLIENTS;
  const [activeConversation, setActiveConversation] = useState(null);
  const [showNewMessage, setShowNewMessage] = useState(false);
  const [uniqueName, setUniqueName] = useState("");
  const navigate = useNavigate();
  const filterConversationsByType = (conversations, inboxType) => {
    if (!archiveEnabled) return conversations;
    if (inboxType === InboxTypes.INBOX) {
      let inboxConversations = conversations.filter(conversation => {
        var _conversation$state, _conversation$lastMes;
        const conversationIsActive = (conversation === null || conversation === void 0 || (_conversation$state = conversation.state) === null || _conversation$state === void 0 ? void 0 : _conversation$state.current) === 'active';
        const hasUnreadMessages = (conversation === null || conversation === void 0 ? void 0 : conversation.lastReadMessageIndex) !== (conversation === null || conversation === void 0 || (_conversation$lastMes = conversation.lastMessage) === null || _conversation$lastMes === void 0 ? void 0 : _conversation$lastMes.index);
        return conversationIsActive || hasUnreadMessages;
      });
      return inboxConversations;
    }
    if (inboxType === InboxTypes.ARCHIVE) {
      let archiveConversations = conversations.filter(conversation => {
        var _conversation$state2, _conversation$lastMes2;
        const conversationIsInactive = (conversation === null || conversation === void 0 || (_conversation$state2 = conversation.state) === null || _conversation$state2 === void 0 ? void 0 : _conversation$state2.current) === 'inactive';
        const hasUnreadMessages = (conversation === null || conversation === void 0 ? void 0 : conversation.lastReadMessageIndex) !== (conversation === null || conversation === void 0 || (_conversation$lastMes2 = conversation.lastMessage) === null || _conversation$lastMes2 === void 0 ? void 0 : _conversation$lastMes2.index);
        return conversationIsInactive && !hasUnreadMessages;
      });
      return archiveConversations;
    }
  };
  const resetState = () => {
    navigate("/message-center");
  };
  useEffect(() => {
    let unsubscribe;
    const getconversations = async () => {
      try {
        let twilioList = await twilioClient.getSubscribedConversations();
        let conversations = twilioList.items;
        while (twilioList.hasNextPage) {
          twilioList = await twilioList.nextPage();
          conversations = [...conversations, ...twilioList.items];
        }
        const unfilteredList = sortConversationsByDate(await Promise.all(conversations.map(transformConversation)));
        setRawConversationList(sortConversationsByDate(unfilteredList));
      } catch (error) {
        messageCenterLogger('Failed to retrieve conversations', {}, error);
        setRawConversationList([]);
      }
    };
    const subscribeToNewMessages = async () => {
      try {
        const callback = async () => {
          try {
            await getconversations();
          } catch (error) {
            messageCenterLogger('Error while handling conversation update event', {}, error);
          }
        };
        twilioClient.on('conversationUpdated', callback);
        unsubscribe = () => {
          twilioClient.off('conversationUpdated', callback);
        };
      } catch (error) {
        messageCenterLogger('Failed to subscribe to new message events', {}, error);
      }
    };
    getconversations().then(() => setInitialized(true)).catch(error => messageCenterLogger('Error during initial conversation retrieval', {}, error));
    subscribeToNewMessages();
    return () => {
      // clean up
      unsubscribe && unsubscribe();
    };
  }, [twilioClient, inboxType]);
  let conversationList = sortConversationsByUnreadStatus(filterConversationsByType(rawConversationList, inboxType));
  let conversationsLength = conversationList.length;
  conversationList = conversationList.slice(pageIndex * CONVERSATIONS_PER_PAGE, offset);
  return {
    initialized,
    rawConversationList,
    conversationList,
    inboxType,
    setInboxType,
    activeConversation,
    setActiveConversation,
    showNewMessage,
    setShowNewMessage,
    uniqueName,
    setUniqueName,
    resetState,
    /** Pagination stuff */
    conversationPageSize: CONVERSATIONS_PER_PAGE,
    conversationsLength
  };
};
export const useMessageAdded = (conversationId, initialState) => {
  const {
    twilioClient
  } = CLIENTS;
  const [messageList, setMessageList] = useState(initialState);
  const getMessages = async convo => {
    const {
      items
    } = await convo.getMessages();
    setMessageList(parseMessagesByDate(items));
  };
  useEffect(() => {
    setMessageList(initialState);
    let twilioConversation = null;
    let isSubscribed = true;
    const onMessageAdded = async () => {
      await getMessages(twilioConversation);
      twilioConversation.setAllMessagesRead();
    };
    const subscribe = async () => {
      twilioConversation = await twilioClient.getConversationBySid(conversationId);
      if (isSubscribed) {
        twilioConversation.on('messageAdded', onMessageAdded);
      }
    };
    subscribe();
    return () => {
      isSubscribed = false;
      if (twilioConversation) {
        twilioConversation.removeListener('messageAdded', onMessageAdded);
      }
    };
  }, [conversationId, twilioClient, initialState, window.location]);
  return messageList;
};
//# sourceMappingURL=useConversations.js.map